module.exports = __webpack_public_path__ + "img/card_dreh.9bbe77ba.jpg";